import { Injectable } from '@angular/core';
import { ComplexArticleBlueprintDTO } from '@admintool/article/generate-article/complex-article-blueprints/complex-article-blueprint';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable, of } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ComplexArticleBlueprintDataService {

  constructor(
    private readonly wagoApiClient: WagoApiClient,
    ) {
  }

  public getAll(): Observable<ComplexArticleBlueprintDTO[]> {
    return this.wagoApiClient.get<ComplexArticleBlueprintDTO[]>('admintool/complex-article-blueprints');
  }

  public getById(id: number): Observable<ComplexArticleBlueprintDTO> {
    return this.wagoApiClient.get<ComplexArticleBlueprintDTO>(`admintool/complex-article-blueprint/${id}`);
  }

  public create(complexArticleBlueprint: ComplexArticleBlueprintDTO): Observable<ComplexArticleBlueprintDTO> {
    return this.wagoApiClient.post<ComplexArticleBlueprintDTO>(`admintool/complex-article-blueprint`, complexArticleBlueprint);
  }

  public save(complexArticleBlueprint: ComplexArticleBlueprintDTO): Observable<ComplexArticleBlueprintDTO> {
    if (!complexArticleBlueprint?.id) {
      return of();
    }
    return this.wagoApiClient.put<ComplexArticleBlueprintDTO>(
      `admintool/complex-article-blueprint/${complexArticleBlueprint.id}`,
      complexArticleBlueprint
    );
  }

  public delete(id: number): Observable<void> {
    return this.wagoApiClient.delete(`admintool/complex-article-blueprint/${id}`);
  }
}
